import React from "react";
import {
  ListTestimonials as ListTestimonialsType,
  SingleTestimonial
} from "../../models/reviews/testimonial";

import {
  ListCustomReviews as ListCustomReviewsType,
  SingleCustomReview
} from "../../models/reviews/customReview";
import CustomReview from "./CustomReview";
import ListCustomReviews from "./ListCustomReviews";
import ListTestimonials from "./ListTestimonials";
import Testimonial from "./Testimonial";

export interface ReviewsProps {
  title?: string;
  subtitle?: string;
  width?: "normal" | "wide";
  reviewItems?: Array<
    ListTestimonialsType | SingleTestimonial | ListCustomReviewsType | SingleCustomReview
  >;
}

const TestimonialsWrapper = ({ children }) => (
  <aside className="sm:px-8">{children}</aside>
);

const CustomReviewWrapper = ({ children }) => (
  <div className="py-24 bg-brand-primary-40 slice-both--long-section mb-32">
    <aside className="sm:px-8 my-0">{children}</aside>
  </div>
);

const Reviews = (props: ReviewsProps) => {
  const { reviewItems: contentItems, width = "normal" } = props;
  const content = contentItems?.[0];

  const getContentBlock = () => {
    switch (content?._type) {
      case "singleTestimonial": {
        const review = content.singleTestimonial[0];
        if (!review) {
          return null;
        }

        return (
          <TestimonialsWrapper>
            <Testimonial
              key={review._id}
              author={review.name}
              jobPosition={review.jobPosition}
              text={review.description}
              logo={review.logo}
            />
          </TestimonialsWrapper>
        );
      }
      case "listTestimonials":
        return (
          <TestimonialsWrapper>
            <ListTestimonials width={width} content={content} />
          </TestimonialsWrapper>
        );
      case "singleCustomReview": {
        const review = content.singleCustomReview[0];
        if (!review) {
          return null;
        }

        return (
          <CustomReviewWrapper>
            <CustomReview
              key={review._id}
              author={review.name}
              avatar={review.avatar}
              rating={review.rating}
              jobPosition={review.jobPosition}
              text={review.description}
              reviewUrl={review.reviewUrl}
            />
          </CustomReviewWrapper>
        );
      }
      case "listCustomReviews":
        return (
          <CustomReviewWrapper>
            <ListCustomReviews width={width} content={content} />
          </CustomReviewWrapper>
        );
    }
  };

  const contentBlock = getContentBlock();

  if (!contentBlock) {
    return null;
  }

  return contentBlock;
};

export default Reviews;

